import { render, staticRenderFns } from "./reCheckScoring.vue?vue&type=template&id=8c6d2422&scoped=true"
import script from "./reCheckScoring.vue?vue&type=script&lang=js"
export * from "./reCheckScoring.vue?vue&type=script&lang=js"
import style0 from "./reCheckScoring.vue?vue&type=style&index=0&id=8c6d2422&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6d2422",
  null
  
)

export default component.exports